<template>
    <transition name="modal-fade">
        <div :class="{ 'modal': true, 'active': active }" id="_modal_providers">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body">
                        <button class="close" aria-label="Next" type="button" @click="closeModal">
                            <img height="31" width="31" src="/wp-content/themes/bpa-health/dist/images/icons/close.svg" />
                        </button>

                        <slot name="modal-body"></slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
    name: 'Modal',
    props: {
        active: {
            type: Boolean,
            default: false
        },
        closeModal: {
            type: Function,
            required: true
        }
    },
    methods: {
        close () {
            this.$emit( 'close' )
        }
    },
}
</script>

<style lang="scss" scoped>
@import "../../sass/variables";
@import "../../sass/mixins";

.modal {
    .modal-dialog {
        .modal-content {
            background-color: #F0EDE9;

        }
    }
}

.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .5s ease;
}
</style>